import ReactDOM from "react-dom";
import { useModal } from "./ModalContext";
import { useTranslation } from "react-i18next";

export default function Modal() {
  const { t } = useTranslation();
  const { isOpen, title, content, hideModal } = useModal();

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="fixed w-full h-full bg-black/65 top-0 left-0 right-0 bottom-0" onClick={hideModal}>
      <div className="w-full h-full overflow-y-auto overflow-x-hidden absolute top-0 left-0 right-0 bottom-0 flex justify-center items-center p-[40px]">
        <div className="w-full max-w-[945px] bg-white rounded-[20px]" onClick={(e) => e.stopPropagation()}>
            <div className="h-[68px] leading-[68px] text-black font-bold px-[33px] flex flex-nowrap bg-white rounded-t-[20px] text-[22px]">
                <div className="w-[calc(100%-30px)]">{t(title)}</div>
                <div className="w-[20px] !text-center cursor-pointer" onClick={hideModal}>x</div>
            </div>
            <div className="bg-white min-h-[50px] rounded-b-[20px]">
                {content}
            </div>
        </div>
      </div>
    </div>,
    document.body // ensures modal is always at end of DOM
  );
}
